import { FC } from 'react';
import { TBooleanInNumber } from 'src/types/main';
import { booleanToNumber } from 'src/utils/helpers';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { RESTRICTION_ACCESS } from '~/constants/integrations';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import './style.scss';
import classNames from 'classnames';

interface IProps {
  title?: string;
  status: TBooleanInNumber;
  label: string;
  posRestSetting?: RESTRICTION_ACCESS;
  onChange: (status: TBooleanInNumber) => void;
}

export const OrderNotesToggle: FC<IProps> = ({ title, status, label, posRestSetting, onChange }): JSX.Element => {
  return (
    <div className="order-notes-toggle">
      {!!title && <Text text={title} type={TEXT.SECTION_HEADER} />}
      <IntegrationManager setting={posRestSetting} withTooltip>
        <div className={classNames('d-flex align-items-center', !!title ? 'mt-4' : undefined)}>
          <Switcher status={booleanToNumber(status)} onChange={onChange} />
          <Text text={label} type={TEXT.SWITCHER_LABEL} />
        </div>
      </IntegrationManager>
    </div>
  );
};
